import React from 'react';
import { Chip } from '@mui/material';

import palette from 'ui/theme/palette';

export interface PillProps {
  text: string;
  onDelete?: () => void;
  dataCy?: string;
  dataCyDelete?: string;
  size?: 'small' | 'medium';
  style?: 'primary' | 'info' | 'warning' | 'error';
  icon?: React.ReactElement;
}

export const Pill: React.FC<PillProps> = (props) => {
  let backgroundColor, color;

  if (props.style === 'primary') {
    color = palette.primary.main;
    backgroundColor = palette.primary.light;
  } else if (props.style === 'info') {
    color = palette.info.main;
    backgroundColor = palette.info.notice;
  } else if (props.style === 'warning') {
    color = palette.warning.text;
    backgroundColor = palette.warning.light;
  } else if (props.style === 'error') {
    color = palette.error.main;
    backgroundColor = palette.error.background;
  }

  return (
    <Chip
      label={props.text}
      onDelete={props.onDelete}
      variant="outlined"
      data-cy={props.dataCy}
      size={props.size ? props.size : 'medium'}
      icon={props.icon}
      deleteIcon={
        <span
          className="material-icons"
          style={{
            color: palette.primary.main,
            width: '16px',
            fontSize: '10px',
            fontWeight: 'bold'
          }}
          data-cy={props.dataCyDelete}
        >
          clear_rounded
        </span>
      }
      sx={{ color, backgroundColor, '& .MuiChip-icon': { color: 'inherit' } }}
    ></Chip>
  );
};
